import React from 'react'
import CommonIcons from 'frontend/components/common-icons'
import OnlineRoomSchedule from './online-room-schedule'

export default class MrsJezebelOnlineSchedule extends OnlineRoomSchedule {
  renderHelpers () {
    const { schedule: { minPlayers, maxPlayers } } = this.state

    return (
      <div className="helpers">
        <div className="no_strangers_notice helper">
          <CommonIcons item="common-user-secret" className="icon" />
          *All games are private, only your team is allowed in the room, NO&nbsp;STRANGERS.
        </div>

        <div className="game_cost helper">
          <CommonIcons item="common-calendar-alt-r" className="icon" />
          <div className="label">Wednesday - Sunday</div>
          <div className="value">$125 2-4 connections</div>
          <div className="value">$15 each additional</div>
        </div>

        <div className="players_count helper">
          <CommonIcons item="common-users" className="icon" />
          <div className="value">{minPlayers}&ndash;{ maxPlayers} Connections</div>
        </div>
      </div>
    )
  }
}
